import { type AppearanceTypes } from './types';

export const DEFAULT_APPEARANCE: AppearanceTypes = 'normal';
